<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_25"></a><a id="sec9"></a><span class="small">FROM</span> <em>The Bride of E</em></h3>
<h4 class="h4"><a id="sec10"></a>And as in Alice</h4>
<p class="poem">Alice cannot be in the poem, she says, because<br/>She’s only a metaphor for childhood<br/>And a poem is a metaphor already<br/>So we’d only have a metaphor</p>
<p class="poem">Inside a metaphor. Do you see?<br/>They all nod. They see. Except for the girl<br/>With her head in the rabbit hole. From this vantage,<br/>Her bum looks like the flattened backside</p>
<p class="poem">Of a black-and-white panda. She actually has one<br/>In the crook of her arm.<br/>Of course it’s stuffed and not living.<br/>Who would dare hold a real bear so near the outer ear?</p>
<p class="poem">She’s wondering what possible harm might come to her<br/>If she fell all the way down the dark she’s looking through.<br/>Would strange creatures sing songs<br/>Where odd syllables came to a sibilant end at the end.</p>
<p class="poem">Perhaps the sounds would be a form of light hissing.<br/>Like when a walrus blows air<br/>Through two fractured front teeth. Perhaps it would<br/>Take the form of a snake. But if a snake, it would need a tree.</p>
<p class="poem">Could she grow one from seed? Could one make a cat?<br/>Make it sit on a branch and fade away again<br/>The moment you told it that the rude noise it was hearing was<br/>    rational thought<br/>With an axe beating on the forest door.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_e.vue?146e312a